import React from 'react'

const LoadingSpinner = () => {
  return (
    <div className='loading-spinner h-[100vh] w-[100vw]'>
         <div className='flex items-center justify-center h-full w-full p-0 m-0'>
            <div className='spinner-grow inline-block w-[50px] h-[50px] bg-current rounded-full opacity-0 text-white' role='status'>
                <span className='visually-hidden'>Loading...</span>
             </div> 
         </div>
    </div>
  )
}

export default LoadingSpinner